<div>
  <div style="min-height: 500px" class="container-fluid py-5 bg-white px-3 tab-content-border">
    <h4 class="mb-1" *ngIf="doc && doc.name">
      <span class="font-weight-normal">Document - </span>
      <a class="text-primary" [href]="'/documents/' + doc.id + '/download'">{{ doc.name }}</a>
      <small class="text-muted" style="font-size: 60%" *ngIf="doc.autosaved">(Autosaved)</small>
    </h4>
    <div class="document-form-actions mb-3" *ngIf="doc">
      <button (click)="previewDocument()" type="button" class="btn btn-outline-secondary btn-sm mr-2 mb-2" [disabled]="generatingPreview()">
        <span *ngIf="generatingPreview()"><i class="fas fa-spinner fa-spin"></i> Generating...</span>
        <span *ngIf="!generatingPreview()">Preview</span>
      </button>
      <button (click)="previewDocument(true)" type="button" class="btn btn-outline-secondary btn-sm mr-2 mb-2" [disabled]="generatingPreview()">
        <span *ngIf="generatingPreview()"><i class="fas fa-spinner fa-spin"></i> Generating...</span>
        <span *ngIf="!generatingPreview()">Preview Inline</span>
      </button>
      <button (click)="saveDocument()" type="button" *ngIf="doc.is_editable" class="btn btn-primary btn-sm mr-2 mb-2">Save</button>
      <button (click)="saveAndCloseDocument()" type="button" *ngIf="doc.is_editable" class="btn btn-success btn-sm mr-2 mb-2">Save &amp; Close</button>
      <button type="button" class="btn btn-outline-secondary btn-sm mr-2 mb-2" (click)="newSidebarDocument()">New</button>
      <button type="button" (click)="cancelDocument()" class="btn btn-danger btn-sm mr-2 mb-2">Cancel</button>
    </div>
    <app-doc-template-search #docTemplateSearch [by_document_type]="true" [autocomplete]="true" (docTemplateSelection)="onTemplateSelection($event)" [matter_info]="matter_info" [matter_id]="matter_id"></app-doc-template-search>
    <div *ngIf="docTemplateItem">
      <h4 class="mt-5">
        <span class="font-weight-normal">Selected Template - </span>
        <span class="text-primary" *ngIf="!showDocTemplateEdit">{{ docTemplateItem.value }}</span>
        <a *ngIf="showDocTemplateEdit" [href]="'/doc_templates/' + docTemplateItem.id + '/edit?template=' + docTemplateItem.model">{{ docTemplateItem.value }}</a>
      </h4>
      <div *ngIf="docTemplate">
        <p class="text-muted">Description of template</p>
        <p class="bg-light px-3 py-2" [innerHTML]="docTemplate.description | safeHtml"></p>
        <div class="py-2 px-3" *ngIf="doc && doc.document_parts">
          <div class="card mb-2" *ngFor="let documentPart of doc.document_parts; let i = index">
            <h6 class="card-header">
              <a (click)="expandDocumentPart(documentPart)" href="javascript: void(0)"><i [class]="'fa fa-' + (documentPart.expanded ? 'minus' : 'plus') + '-circle'"></i></a>
              &nbsp;&nbsp;&nbsp;
              {{ documentPart.name }}
              <div class="pull-right float-right">
                <div (click)="documentPart.include_part = !documentPart.include_part" class="custom-control custom-checkbox">
                  <input [(ngModel)]="documentPart.include_part" [checked]="documentPart.include_part" type="checkbox" class="custom-control-input" />
                  <label class="custom-control-label">Include Part</label>
                </div>
              </div>
            </h6>
            <div class="card-body" [hidden]="!documentPart.expanded">
              <div style="width: 178mm; margin: 0 auto">
                <div style="width: 100%; border: 1px solid #ccc" [innerHTML]="documentPart.contents | safeHtml" *ngIf="!documentPart.isTinymce"></div>
                <app-tinymce-css
                  [elementId]="'tinymce-' + i + '-document-part-' + i"
                  #tinymceCss
                  [initialContent]="documentPart.contents"
                  (onEditorKeyup)="documentPart.contents = $event"
                  (wordCount)="documentPart.wordCount = $event; calculateWordCount(); documentChanged()"
                  *ngIf="documentPart.isTinymce"
                ></app-tinymce-css>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="preview_inline_holder" style="width: 100%">
        <iframe #previewIframe id="preview_content" frameBorder="0" name="document_preview" width="100%" height="100%"></iframe>
      </div>
    </div>
  </div>
</div>
